<span *ngIf="standLocation">
  <span *ngIf="standLocation.successful">
    {{ 'STAND_DISPLAY.' + standLocation.place | translate }}, {{ 'STAND_DISPLAY.PAVILION' | translate }} {{ pavilionTranslationFinder(standLocation.pavilion,standLocation.place) | translate }},
    {{ 'STAND_DISPLAY.LEVEL' | translate }} {{ standLocation.level }}, {{ 'STAND_DISPLAY.STREET' | translate }} {{ standLocation.street }},
    {{ 'STAND_DISPLAY.STAND' | translate }} {{ standLocation.stand }}
  </span>
  <span *ngIf="!standLocation.successful && standLocation.partial">
    {{ 'STAND_DISPLAY.' + standLocation.place | translate }}<span *ngIf="standLocation.details">, {{ standLocation.details }}</span>
  </span>
  <span *ngIf="!standLocation.successful && !standLocation.partial">
    {{ standData }}
  </span>
</span>